
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
import moment from 'moment';
import { getLearnerDetails, getPreAuthUrl } from '@/utils/admin/operation_tab_details_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { getTaskById } from '@/utils/learner_submit_service';
import { updateOffcyclestatus } from '@/utils/admin/task_management_service';
// eslint-disable-next-line
import router from '@/router';
import { downloadLearnerSubmission } from '../../utils/learner_review_service';

export default defineComponent({
  name: 'OffCycleDetails',
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const learnerTaskId = ref(props.query.learner_task_id);
    const renderReady = ref();
    const getLearner = ref();
    const learnerOtherDetails = ref();
    const learnerTaskDetails = ref();
    const preSignedUrl = ref();
    const errorMessage = ref();
    const loggedInUserRoles = ref();
    const showUpdateBtn = ref(false);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const showdonwloadBtn = ref(true);
    const getLearneRecord = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getLearnerDetails('/learnerDetails', learnerTaskId.value);
        getLearner.value = res.learnerDetails;
        learnerOtherDetails.value = res.otherDetails;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const taskRes: any = await getTaskById(getLearner.value.linked_task_id);
        learnerTaskDetails.value = taskRes.data.data;
        if (getLearner.value) {
          console.log('Learner Status', getLearner.value.learner_status);
          if (getLearner.value.registration_date) {
            getLearner.value.registration_date = moment(getLearner.value.registration_date).format('YYYY-MM-DD');
          }
        }
        renderReady.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const updateRecord = async () => {
      try {
        const updatedData = {
          learnerTaskId: getLearner.value.learner_task_id,
          is_offcycle_active: getLearner.value.is_offcycle_active,
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updateRes: any = await updateOffcyclestatus('/updateOffcycleStatus', updatedData);
        resMessage.value = updateRes.message;
        await getLearneRecord();
        renderReady.value = true;

        showSuccessMessage.value = true;
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 6000);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    const learnerSubmissionClicked = async () => {
      try {
        const data = {
          file_name: getLearner.value.learner_submission,
          task_id: getLearner.value.learner_task_id,
        };
        renderReady.value = false;
        preSignedUrl.value = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
        await downloadLearnerSubmission(preSignedUrl.value, getLearner.value.learner_submission);
        renderReady.value = true;
      } catch (error) {
        console.log('Save Task Data', error);
      }
    };
    const updateSubmission = async () => {
      console.log('update submission');
      router.push({ name: 'SolidifyAdministrationUpdateSubmission', query: { linked_task_id: getLearner.value.linked_task_id, learner_task_id: getLearner.value.learner_task_id } });
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      loggedInUserRoles.value = role.user_roles;
      if (loggedInUserRoles.value.length > 0) {
        if (loggedInUserRoles.value.includes('System Admin') || loggedInUserRoles.value.includes('Program Admin')) {
          showUpdateBtn.value = true;
        }
      } else {
        showUpdateBtn.value = false;
      }
      await getLearneRecord();
    });
    return {
      renderReady,
      getLearner,
      preSignedUrl,
      updateRecord,
      errorMessage,
      learnerSubmissionClicked,
      loggedInUserRoles,
      showUpdateBtn,
      showSuccessMessage,
      resMessage,
      showErrorMessage,
      showdonwloadBtn,
      learnerOtherDetails,
      learnerTaskDetails,
      updateSubmission,
    };
  },
});
